var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 76,
    viewBox: "0 0 186 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.34 34.6645L141.015 15.4883L129.969 15.6113L125.306 15.6595L114.844 42.1806L112.56 47.7438L114.844 47.3654L124.271 45.8109L111.961 75.9991H112.032L143.304 34.2586L133.34 34.6645Z",
    fill: "#EC4E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.951 0L126.164 12.611L141.575 12.6271L146.152 0.178819L130.951 0Z",
    fill: "#EC4E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.642 51.8569L151.814 26.7948L139.836 27.003L144.496 15.5273H186.001L181.43 26.897H170.128L160.071 51.8636L141.642 51.8569Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.361 30.2852L106.594 30.2095L107.994 26.8895H116.694L121.226 15.5151L93.8884 15.5L79.5391 51.8097H97.9681L103.255 38.4986L112.036 38.6159L115.361 30.2852Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6692 51.8479L90.0883 15.5117H53.1529L38.8281 51.8432L50.6103 51.8479L60.0518 27.2135H67.0159L57.2534 51.8546L75.6692 51.8479Z",
    fill: "#212121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4456 15.5157L0 51.7526H35.1472L49.2614 15.5044L31.7294 15.4883L21.9243 40.3044H15.2481L25.0627 15.5157H14.4456Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo_main.d340f4750db30387e995d1706b082c25.svg";
export { ForwardRef as ReactComponent };